<template>
<div>
<v-card class="mx-auto mb-4" outlined v-if="apiResult.description">
  <v-card-title>Etimologia / Derivazione <span class=origin>Da Wikimedia</span></v-card-title>
  <v-card-text class="text--primary description">{{apiResult.description}}</v-card-text>
  <v-card-text >
    <div v-for="apidata in apiResult.data" :key="apidata.description" class="block d-inline-block mr-4">
      <div class="text-center"><img width=100 :src="apidata.img" :alt="apidata.description"></div>
      <div class="block-bottom text-center">{{apidata.description}}</div>
    </div>
  </v-card-text>
</v-card>
</div>  
</template>

<script>
import Api from "@/services/Api"
export default {
  data() {
    return {
      apiResult:{}
    }
  },
  props:["kanjiData"],
  watch: {
  },
  mounted(){
    this.getData();
  },
  methods: {
    getData() {
      Api().get("api/3rd/wikimedia?keyword="+this.kanjiData.literal).then(res=>{
        console.log ("----",res);
        this.apiResult = res.data;
      });
    }
  }
}
</script>

<style scoped>
.block {
  width:190px;
  height:190px;
  border:1px solid #aaaaaa;
  vertical-align:top;
  border-radius:4px;
  position:relative;
  padding-top:16px;
}
.block-bottom {
  position:absolute;
  bottom:0;
  width:100%;
}
.origin {
  font-size:10px;
  color:#aaaaaa;
  vertical-align:middle;
  display:inline-block;
  margin-left:16px;
}
.description::first-letter {
  text-transform: uppercase;
}
</style>